import { type FC } from 'react';
import { Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

type ErrorType = 'token-expired';

interface ErrorPageUrlParams {
	errorType: ErrorType;
}

const Error: FC = () => {
	const { errorType } = useParams<ErrorPageUrlParams>();

	return (
		<Alert variant="danger">
			{errorType === 'token-expired' && (
				<>
					Your authentication token is expired. Please close all editor tabs, return to the admin
					site and log in, and then relaunch the editor.
				</>
			)}
		</Alert>
	);
};

export default Error;
